import React from 'react';
import { Typography, Card, CardContent, Box, Grid } from '@mui/material';
import { Spacer } from 'src/components/shared';
import { Skeleton } from '@mui/lab';

const ReportCard = ({ title, value, loading, subTitle, hideCurrency = false }) => {
  return (
    <Grid item xs={4} md={4} lg={3}>
      <Card>
        <CardContent>
          <Box>
            <Box display="flex" justifyContent="center" alignItems="center">
              {typeof title === 'string' ? (
                <Typography variant="body2" color="textSecondary">
                  {title}
                </Typography>
              ) : (
                title
              )}
            </Box>
            <Spacer x={1} y={2} />
            <Box display="flex" justifyContent="center" alignItems="center">
              <Typography
                color="#00000061"
                fontSize={'13px'}
                minHeight={'16px'}
                fontWeight={500}
                lineHeight={'16px'}
              >
                {subTitle}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '80px' }}>
              {loading ? (
                <Skeleton animation="wave" height={36} width={40} />
              ) : (
                <Typography sx={{ fontSize: '24px', fontWeight: 600 }}>
                  {hideCurrency ? '' : '$'}
                  {value}
                </Typography>
              )}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ReportCard;
